import { isEmpty } from 'lodash';

const getRequestApprovalStatusResponse = (response) => {
  if (isEmpty(response?.data?.list)) return [];

  return response?.data?.list?.map((status) => {
    return {
      id: status?.id,
      value: status?.id?.toString(),
      label: status?.name,
    };
  });
};

export default getRequestApprovalStatusResponse;
